// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@pace/App/Components/Common/XngZone";
import XngSticky from "@pace/App/Components/XngSticky";
import { CustomAppState } from "@pace/App/Store/Reducers";
import * as React from "react";
import { connect } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomAppState, props: OwnProps) => {
    return {
        isMobileScreen: (state as CustomAppState).xCommon.isMobileScreen,
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface MyAccountViewStyles {
    quickLinksGridItem?: GridItemProps;
    mainSectionGridItem?: GridItemProps;
    mainSectionGridContainer?: GridContainerProps;
    accountMessagesGridItem?: GridItemProps;
    dashboardWidgetsGridItem?: GridItemProps;
    // XNG-Changes
    myAccountHeaderGridItem?: GridItemProps;
    pageWrapper?: InjectableCss;
}

export const myAccountViewStyles: MyAccountViewStyles = {
    quickLinksGridItem: { width: [12, 12, 12, 2, 2] },
    mainSectionGridItem: { width: [12, 12, 12, 10, 10] },
    accountMessagesGridItem: { width: 12 },
    dashboardWidgetsGridItem: { width: 12 },
};

const styles = myAccountViewStyles;

class MyAccountView extends React.PureComponent<Props> {
    render() {
        return (
            <>
                {/* // XNG-Changes */}
                {this.props.isMobileScreen && (
                    <StyledWrapper {...styles.myAccountHeaderGridItem} data-test-selector="mobileHeader">
                        <Zone contentId={this.props.id} zoneName="myDashboardHeader" />
                    </StyledWrapper>
                )}
                <StyledWrapper {...styles.pageWrapper}>
                    <StyledWrapper {...styles.quickLinksGridItem}>
                        <XngSticky stopBreakpoint="sm">
                            <XngZone hint="Navigation List" contentId={this.props.id} zoneName="NavigationList" />
                        </XngSticky>
                    </StyledWrapper>
                    <StyledWrapper {...styles.mainSectionGridItem}>
                        {!this.props.isMobileScreen && (
                            <StyledWrapper {...styles.myAccountHeaderGridItem}>
                                <Zone contentId={this.props.id} zoneName="myDashboardHeader" />
                            </StyledWrapper>
                        )}
                        {/* <StyledWrapper {...styles.accountMessagesGridItem}>
                            <AccountMessages />
                        </StyledWrapper> */}
                        <StyledWrapper {...styles.dashboardWidgetsGridItem}>
                            <XngZone hint="Dashboard Widgets" contentId={this.props.id} zoneName="DashboardWidgets" />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </>
        );
    }
}

const myAccountViewWidget: WidgetModule = {
    component: connect(mapStateToProps)(MyAccountView),
    definition: {
        // XNG-Changes
        allowedContexts: ["MyAccountPage", "PreviouslyPurchasedPage"],
        group: "My Account",
    },
};

export default myAccountViewWidget;
